"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * The Jira Cloud platform REST API
 * Jira Cloud platform REST API documentation
 *
 * The version of the OpenAPI document: 1001.0.0-SNAPSHOT-1df5db7255b44a0b9aa806f0b2de7cddb4bbffc9
 * Contact: ecosystem@atlassian.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.WorkflowToJSON = exports.WorkflowFromJSONTyped = exports.WorkflowFromJSON = exports.instanceOfWorkflow = void 0;
const ProjectDetails_1 = require("./ProjectDetails");
const PublishedWorkflowId_1 = require("./PublishedWorkflowId");
const Transition_1 = require("./Transition");
const WorkflowOperations_1 = require("./WorkflowOperations");
const WorkflowSchemeIdName_1 = require("./WorkflowSchemeIdName");
const WorkflowStatus_1 = require("./WorkflowStatus");
/**
 * Check if a given object implements the Workflow interface.
 */
function instanceOfWorkflow(value) {
    if (!('description' in value))
        return false;
    if (!('id' in value))
        return false;
    return true;
}
exports.instanceOfWorkflow = instanceOfWorkflow;
function WorkflowFromJSON(json) {
    return WorkflowFromJSONTyped(json, false);
}
exports.WorkflowFromJSON = WorkflowFromJSON;
function WorkflowFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'created': json['created'] == null ? undefined : (new Date(json['created'])),
        'description': json['description'],
        'hasDraftWorkflow': json['hasDraftWorkflow'] == null ? undefined : json['hasDraftWorkflow'],
        'id': (0, PublishedWorkflowId_1.PublishedWorkflowIdFromJSON)(json['id']),
        'isDefault': json['isDefault'] == null ? undefined : json['isDefault'],
        'operations': json['operations'] == null ? undefined : (0, WorkflowOperations_1.WorkflowOperationsFromJSON)(json['operations']),
        'projects': json['projects'] == null ? undefined : (json['projects'].map(ProjectDetails_1.ProjectDetailsFromJSON)),
        'schemes': json['schemes'] == null ? undefined : (json['schemes'].map(WorkflowSchemeIdName_1.WorkflowSchemeIdNameFromJSON)),
        'statuses': json['statuses'] == null ? undefined : (json['statuses'].map(WorkflowStatus_1.WorkflowStatusFromJSON)),
        'transitions': json['transitions'] == null ? undefined : (json['transitions'].map(Transition_1.TransitionFromJSON)),
        'updated': json['updated'] == null ? undefined : (new Date(json['updated'])),
    };
}
exports.WorkflowFromJSONTyped = WorkflowFromJSONTyped;
function WorkflowToJSON(value) {
    if (value == null) {
        return value;
    }
    return {
        'created': value['created'] == null ? undefined : ((value['created']).toISOString()),
        'description': value['description'],
        'hasDraftWorkflow': value['hasDraftWorkflow'],
        'id': (0, PublishedWorkflowId_1.PublishedWorkflowIdToJSON)(value['id']),
        'isDefault': value['isDefault'],
        'operations': (0, WorkflowOperations_1.WorkflowOperationsToJSON)(value['operations']),
        'projects': value['projects'] == null ? undefined : (value['projects'].map(ProjectDetails_1.ProjectDetailsToJSON)),
        'schemes': value['schemes'] == null ? undefined : (value['schemes'].map(WorkflowSchemeIdName_1.WorkflowSchemeIdNameToJSON)),
        'statuses': value['statuses'] == null ? undefined : (value['statuses'].map(WorkflowStatus_1.WorkflowStatusToJSON)),
        'transitions': value['transitions'] == null ? undefined : (value['transitions'].map(Transition_1.TransitionToJSON)),
        'updated': value['updated'] == null ? undefined : ((value['updated']).toISOString()),
    };
}
exports.WorkflowToJSON = WorkflowToJSON;
//# sourceMappingURL=Workflow.js.map